import { render, staticRenderFns } from "./SendTextModal.vue?vue&type=template&id=ecaf5ed8&"
import script from "./SendTextModal.vue?vue&type=script&lang=js&"
export * from "./SendTextModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports